import React, {Suspense, lazy} from "react";
import {createBrowserRouter, RouterProvider, Outlet, Navigate} from "react-router-dom";
import NavMenu from "./components/NavMenu";
import NotFound from "./components/NotFound";
import Loader from "./components/Loader";

// Lazy loading des pages principales
const Welcome = lazy(() => import("./components/Welcome"));
const Financials = lazy(() => import("./components/Financials"));
const Report = lazy(() => import("./components/Report"));
const HelpCenter = lazy(() => import("./components/HelpCenter"));
const CGU = lazy(() => import("./components/CGU"));
const SigninOIDC = lazy(() => import("./components/SigninOIDC"));
const SsoFntp = lazy(() => import("./components/SsoFntp"));
const Login = lazy(() => import("./components/Login"));
const AuthRedirect = lazy(() => import("./components/AuthRedirect"));

// Composant wrapper pour Suspense
const LazyPage = ({children}) => (
	<Suspense
		fallback={
			<div className="centerAlign paddingTop50">
				<Loader />
			</div>
		}
	>
		{children}
	</Suspense>
);

const Routes = (props) => {
	const router = createBrowserRouter([
		{
			path: "/ffb",
			element: (
				<LazyPage>
					<AuthRedirect provider="ffb" handleSignin={props.handleSignin} setUserProvider={props.setUserProvider} />
				</LazyPage>
			),
		},
		{
			path: "/fntp",
			element: (
				<LazyPage>
					<AuthRedirect provider="fntp" handleSignin={props.handleSignin} setUserProvider={props.setUserProvider} />
				</LazyPage>
			),
		},
		{
			path: "/login",
			element: (
				<LazyPage>
					<Login {...props} />
				</LazyPage>
			),
		},
		{
			path: "/signin-oidc",
			element: (
				<LazyPage>
					<SigninOIDC {...props} />
				</LazyPage>
			),
		},
		{
			path: "/sso-fntp/:token",
			element: (
				<LazyPage>
					<SsoFntp {...props} />
				</LazyPage>
			),
		},
		{
			// Le composant retire le jeton de l'URL dès qu'il l'a lu : cette route sert les
			// rechargements qui suivent, et affiche un message clair plutôt qu'un 404.
			path: "/sso-fntp",
			element: (
				<LazyPage>
					<SsoFntp {...props} />
				</LazyPage>
			),
		},
		{
			path: "/",
			element: (
				<div className="App">
					<NavMenu {...props} />
					<div className="appContent">
						<Outlet />
					</div>
				</div>
			),
			errorElement: <NotFound />,
			children: [
				{
					path: "/",
					element: <Navigate to="/bienvenue" replace />,
				},
				{
					path: "/bienvenue",
					element: (
						<LazyPage>
							<Welcome {...props} />
						</LazyPage>
					),
				},
				{
					path: "/etats-financiers",
					element: (
						<LazyPage>
							<Financials {...props} />
						</LazyPage>
					),
				},
				{
					path: "/analyses",
					element: (
						<LazyPage>
							<Report {...props} />
						</LazyPage>
					),
				},
				{
					path: "/centre-aide",
					element: (
						<LazyPage>
							<HelpCenter {...props} />
						</LazyPage>
					),
				},
				{
					path: "/conditions-generales-utilisation",
					element: (
						<LazyPage>
							<CGU {...props} />
						</LazyPage>
					),
				},
			],
		},
	]);

	return <RouterProvider router={router} />;
};

export default Routes;
